import { AppRouter } from 'app/routers';
import { Providers } from 'app/providers';
import { GlobalStyle } from 'app/styles';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
	return (
		<>
			<GlobalStyle />
			<ToastContainer
				position="bottom-left"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
			/>
			<Providers>
				<AppRouter />
			</Providers>
		</>
	);
}

export default App;
